import { format } from 'date-fns/format';

import { getDateWithOffset } from './get-date-with-offset';

/**
 * A small function returns the current day of the week, formatted either in a
 * short or full form based on the optional `variation` parameter.
 */
export function getCurrentWeekDay(variation: 'short' | 'full', utcOffsetHours?: number) {
  const displayFormat = variation === 'short' ? 'EEE' : 'EEEE';
  const currentDate = new Date();

  if (utcOffsetHours) {
    const currentDateWithOffset = getDateWithOffset(currentDate, utcOffsetHours); // prettier-ignore

    return format(currentDateWithOffset, displayFormat);
  }

  return format(currentDate, displayFormat);
}
